import styled from "styled-components";

const OutletContainer = styled.main`
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.base1};
`;

export default OutletContainer;
